import { splitProps, type Component, type JSX } from "solid-js";
import { Dynamic } from "solid-js/web";
import { cn } from "@/lib/cn";

type IconWeight = "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
type IconSize = "xs" | "sm" | "md" | "lg" | "xl";

export type PhosphorIcon = (
  props: JSX.SvgSVGAttributes<SVGSVGElement> & {
    size?: string | number;
    weight?: IconWeight;
    mirrored?: boolean;
  },
  ref?: unknown,
) => JSX.Element;

const iconSizes: Record<IconSize, string> = {
  xs: "size-3",
  sm: "size-4",
  md: "size-5",
  lg: "size-6",
  xl: "size-8",
};

export interface IconProps extends JSX.SvgSVGAttributes<SVGSVGElement> {
  as: PhosphorIcon;
  size?: IconSize;
  title?: string;
  weight?: IconWeight;
}

export function Icon(props: IconProps) {
  const [local, rest] = splitProps(props, ["as", "class", "size", "title", "weight"]);

  return (
    <Dynamic
      component={local.as as Component<Record<string, unknown>>}
      aria-hidden={local.title ? undefined : "true"}
      aria-label={local.title}
      class={cn("shrink-0 text-current", iconSizes[local.size ?? "sm"], local.class)}
      size="1em"
      weight={local.weight ?? "regular"}
      {...rest}
    />
  );
}
